import { Nullable } from "@core/domain/types/nullable.type";
import { CategoryGroupBudgetDto } from "@project/data/dto/budget.dto";
import { CreateBudgetCategoryGroupBody } from "@project/data/dto/budget/category/groups/create-budget-category-group.body";
import { CreateBudgetCategoryGroup } from "@project/domain/models/budget/budget-category/groups/create-budget-category-group.model";
import { BudgetCategoryGroup } from "@project/domain/models/budget/financial-entity-budget.model";
import { validateSync } from "class-validator";
import { injectable } from "inversify";

@injectable()
export class CreateBudgetCategoryGroupMapper {
    map(
        budgetCategoryGroupDto: CategoryGroupBudgetDto,
    ): Nullable<BudgetCategoryGroup> {
        const errors = validateSync(budgetCategoryGroupDto);
        if (errors.length) {
            console.error(errors);
            return null;
        }
        return new BudgetCategoryGroup(
            budgetCategoryGroupDto.id,
            budgetCategoryGroupDto.name,
            budgetCategoryGroupDto.category,
            budgetCategoryGroupDto.expense_type_mapping,
            budgetCategoryGroupDto.expense_subtype_mapping,
        );
    }
    mapToDto(
        createBudgetCategoryGroup: CreateBudgetCategoryGroup,
    ): CreateBudgetCategoryGroupBody {
        const body: CreateBudgetCategoryGroupBody = {
            name: createBudgetCategoryGroup.name,
            category: createBudgetCategoryGroup.category,
        };

        // Normalize: send null when empty string/undefined
        const typeVal = createBudgetCategoryGroup.expense_type_mapping;
        const subtypeVal = createBudgetCategoryGroup.expense_subtype_mapping;
        if (typeVal !== undefined) {
            body.expense_type_mapping = typeVal && typeVal.trim() !== "" ? typeVal : null;
        }
        if (subtypeVal !== undefined) {
            body.expense_subtype_mapping = subtypeVal && subtypeVal.trim() !== "" ? subtypeVal : null;
        }

        return body;
    }
}
